import { chainedInstruction } from '@angular/compiler/src/render3/view/util';
import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var tableau: any;

@Component({
  selector: 'app-tableau-embed',
  templateUrl: './tableau-embed.component.html',
  styleUrls: ['./tableau-embed.component.scss']
})
export class TableauEmbedComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy{
  /** 画面エレメントのID */
  @Input() public elementId: string;
  /** 表示するviewのURLのディレクトリ */
  @Input() url: string;

  /** ビューコントローラ */
  private viz: any;

  /**
   * コンストラクタ
   */
  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.url) {
      this.initViz(environment.tableauHost + this.url);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.url) {
      if (changes.url.previousValue !== changes.url.currentValue && changes.url.currentValue) {
        this.initViz(environment.tableauHost + changes.url.currentValue);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.viz) {
      this.viz.dispose();
    }
    this.viz = null;
  }

  /**
   * Tableau表示
   * @param url 表示するビューのURL
   */
  private initViz(url: string): void {
    // すでに実体化していれば削除
    if (this.viz) {
      this.viz.dispose();
    }
    this.viz = null;

    // Tableau実体化
    this.viz = new tableau.Viz(document.getElementById(this.elementId), url, {
      width: '100%',
      height: '100%',
      hideToolbar: true
    });
  }

  /**
   * Excelダウンロード
   */
  public downloadExcel(): void {
    this.viz.exportCrossTabToExcel();
  }
}
